import { render, staticRenderFns } from "./BaseImageUploadInput.vue?vue&type=template&id=42156f25&scoped=true"
import script from "./BaseImageUploadInput.vue?vue&type=script&lang=js"
export * from "./BaseImageUploadInput.vue?vue&type=script&lang=js"
import style0 from "./BaseImageUploadInput.vue?vue&type=style&index=0&id=42156f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42156f25",
  null
  
)

export default component.exports